import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_CONFIG_QUERY_KEY, getAccountConfig } from '@/api/accountConfig';
import type { UserProfile } from '@/api/user';

// Branding and features rarely change within a session.
const ACCOUNT_CONFIG_STALE_TIME_MS = 5 * 60 * 1000;

/** Shared by the config and branding hooks so both read one cached request. */
export const useAccountConfigQuery = (user: UserProfile | null | undefined, enabled = true) =>
  useQuery({
    queryKey: ACCOUNT_CONFIG_QUERY_KEY,
    queryFn: getAccountConfig,
    enabled: enabled && Boolean(user),
    staleTime: ACCOUNT_CONFIG_STALE_TIME_MS,
  });
